import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_swplugin_e544f570 from 'nuxt_plugin_swplugin_e544f570' // Source: ./sw.plugin.js (mode: 'client')
import nuxt_plugin_plugin_21950bf5 from 'nuxt_plugin_plugin_21950bf5' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_moment_179c8849 from 'nuxt_plugin_moment_179c8849' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_libplugin2f94fb99_41f63ce8 from 'nuxt_plugin_libplugin2f94fb99_41f63ce8' // Source: ./lib.plugin.2f94fb99.js (mode: 'all')
import nuxt_plugin_nuxticons_1cff5f79 from 'nuxt_plugin_nuxticons_1cff5f79' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_axios_e6a621a2 from 'nuxt_plugin_axios_e6a621a2' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_5d7de2ec from 'nuxt_plugin_pluginutils_5d7de2ec' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_a8dd3592 from 'nuxt_plugin_pluginrouting_a8dd3592' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2e5d2cd0 from 'nuxt_plugin_pluginmain_2e5d2cd0' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_filters_772f0c34 from 'nuxt_plugin_filters_772f0c34' // Source: ../filters (mode: 'client')
import nuxt_plugin_aggrid_b70d0752 from 'nuxt_plugin_aggrid_b70d0752' // Source: ../plugins/ag-grid (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'client')
import nuxt_plugin_vuehandsontable_da120170 from 'nuxt_plugin_vuehandsontable_da120170' // Source: ../plugins/vue-handsontable (mode: 'client')
import nuxt_plugin_vueuuid_9db4d5d0 from 'nuxt_plugin_vueuuid_9db4d5d0' // Source: ../plugins/vue-uuid (mode: 'client')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ../plugins/vuelidate (mode: 'client')
import nuxt_plugin_vuequilleditor_67e94cdc from 'nuxt_plugin_vuequilleditor_67e94cdc' // Source: ../plugins/vue-quill-editor (mode: 'client')
import nuxt_plugin_vuetifydaterangepicker_41606abe from 'nuxt_plugin_vuetifydaterangepicker_41606abe' // Source: ../plugins/vuetify-daterange-picker (mode: 'client')
import nuxt_plugin_vuetifydatetimepicker_cdb158aa from 'nuxt_plugin_vuetifydatetimepicker_cdb158aa' // Source: ../plugins/vuetify-datetime-picker (mode: 'client')
import nuxt_plugin_vuetifycolorpicker_5e2f958d from 'nuxt_plugin_vuetifycolorpicker_5e2f958d' // Source: ../plugins/vuetify-color-picker (mode: 'client')
import nuxt_plugin_componentes_7020d6bc from 'nuxt_plugin_componentes_7020d6bc' // Source: ../plugins/componentes.js (mode: 'client')
import nuxt_plugin_translator_12f4c5e7 from 'nuxt_plugin_translator_12f4c5e7' // Source: ../plugins/translator.js (mode: 'client')
import nuxt_plugin_plugin_80ecc5aa from 'nuxt_plugin_plugin_80ecc5aa' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","beforeEnter":function(el) {
      //console.log("Before enter...")
    },"appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Certiapp","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"certiapp-nuxt"},{"hid":"theme-color","name":"theme-color","content":"#ffb70f"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"certiapp-nuxt"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"certiapp-nuxt"}],"link":[{"rel":"icon","href":"\u002Ffavicon.ico?v=2"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:300,400,500,700|Material+Icons"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@5.x\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.a66cabc0.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64.chFeVr8Wpv1.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512.chFeVr8Wpv1.png","sizes":"512x512"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_swplugin_e544f570 === 'function') {
    await nuxt_plugin_swplugin_e544f570(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_21950bf5 === 'function') {
    await nuxt_plugin_plugin_21950bf5(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_179c8849 === 'function') {
    await nuxt_plugin_moment_179c8849(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin2f94fb99_41f63ce8 === 'function') {
    await nuxt_plugin_libplugin2f94fb99_41f63ce8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_1cff5f79 === 'function') {
    await nuxt_plugin_nuxticons_1cff5f79(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_e6a621a2 === 'function') {
    await nuxt_plugin_axios_e6a621a2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_5d7de2ec === 'function') {
    await nuxt_plugin_pluginutils_5d7de2ec(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_a8dd3592 === 'function') {
    await nuxt_plugin_pluginrouting_a8dd3592(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2e5d2cd0 === 'function') {
    await nuxt_plugin_pluginmain_2e5d2cd0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filters_772f0c34 === 'function') {
    await nuxt_plugin_filters_772f0c34(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aggrid_b70d0752 === 'function') {
    await nuxt_plugin_aggrid_b70d0752(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuehandsontable_da120170 === 'function') {
    await nuxt_plugin_vuehandsontable_da120170(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueuuid_9db4d5d0 === 'function') {
    await nuxt_plugin_vueuuid_9db4d5d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuequilleditor_67e94cdc === 'function') {
    await nuxt_plugin_vuequilleditor_67e94cdc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetifydaterangepicker_41606abe === 'function') {
    await nuxt_plugin_vuetifydaterangepicker_41606abe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetifydatetimepicker_cdb158aa === 'function') {
    await nuxt_plugin_vuetifydatetimepicker_cdb158aa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetifycolorpicker_5e2f958d === 'function') {
    await nuxt_plugin_vuetifycolorpicker_5e2f958d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_componentes_7020d6bc === 'function') {
    await nuxt_plugin_componentes_7020d6bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_translator_12f4c5e7 === 'function') {
    await nuxt_plugin_translator_12f4c5e7(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_80ecc5aa === 'function') {
    await nuxt_plugin_plugin_80ecc5aa(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
